import { useEffect } from "react";
import type { AdminTab } from "../types/admin";

type UseAdminActiveTabLoaderParams = {
  activeTab: AdminTab;
  isAdmin: boolean;
  isOrganizer: boolean;
  isStaff: boolean;
  loadCategoryChangeRequests: () => void;
  loadEventLinks: () => void;
  loadEventRegistrations: () => void;
  loadHistory: () => void;
  loadPaymentsSettings: () => void;
  loadUsers: () => void;
  showChallengeModal: boolean;
  token?: string | null;
  usersCount: number;
  usersLoading: boolean;
};

export function useAdminActiveTabLoader({
  activeTab,
  isAdmin,
  isOrganizer,
  isStaff,
  loadCategoryChangeRequests,
  loadEventLinks,
  loadEventRegistrations,
  loadHistory,
  loadPaymentsSettings,
  loadUsers,
  showChallengeModal,
  token,
  usersCount,
  usersLoading,
}: UseAdminActiveTabLoaderParams) {
  useEffect(() => {
    if (!isStaff || !token) return;
    if (activeTab === "users") {
      if (isAdmin || isOrganizer) {
        loadUsers();
      }
      return;
    }
    if (activeTab === "history") {
      loadHistory();
      return;
    }
    if (activeTab === "content") {
      if (isAdmin) {
        loadEventLinks();
      }
      return;
    }
    if (activeTab === "registrations") {
      loadEventRegistrations();
      return;
    }
    if (activeTab === "categoryRequests") {
      if (isAdmin) {
        loadCategoryChangeRequests();
      }
      return;
    }
    if (activeTab === "payments") {
      loadPaymentsSettings();
    }
  }, [
    activeTab,
    isAdmin,
    isOrganizer,
    isStaff,
    token,
    loadUsers,
    loadHistory,
    loadEventLinks,
    loadEventRegistrations,
    loadCategoryChangeRequests,
    loadPaymentsSettings,
  ]);

  useEffect(() => {
    if ((!isAdmin && !isOrganizer) || !token) return;
    const needsUsers = activeTab === "history" || showChallengeModal;
    if (!needsUsers) return;
    if (usersLoading) return;
    if (usersCount > 0) return;
    loadUsers();
  }, [
    activeTab,
    isAdmin,
    isOrganizer,
    token,
    showChallengeModal,
    usersCount,
    usersLoading,
    loadUsers,
  ]);
}
